var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 6,
    preserveAspectRatio: "none",
    viewBox: "0 0 12 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#99A3AC",
    d: "M1.625.22a1 1 0 0 0-1.25 1.56l5 4a1 1 0 0 0 1.25 0l5-4a1 1 0 1 0-1.25-1.56L6 3.72z"
  })));
};
export default SvgChevronDown;